import { UserSettingsRoutes } from '@/routes/user/settings'

export const regulationsSettingsRouteNames = [
  UserSettingsRoutes.SmsVoiceTollFree,
  UserSettingsRoutes.SmsVoiceTenDlc,
  UserSettingsRoutes.SmsVoiceTenDlcCampaign,
  UserSettingsRoutes.SmsVoiceTenDlcCampaignOverview,
  UserSettingsRoutes.SmsVoiceTenDlcCampaignNumbers,
]

export enum OldSmsSurveyRoutes {
  index = 'user.services.smsSurveys',
  overview = 'user.services.smsSurveys.overview',
  details = 'user.services.smsSurveys.details',
  detailsOverview = 'user.services.smsSurveys.details.overview',
  detailsReplies = 'user.services.smsSurveys.details.replies',
  detailsAnalytics = 'user.services.smsSurveys.details.analytics',
}

export enum OldCarrierLookupRoutes {
  index = 'user.services.carrierLookup',
  singleLookup = 'user.services.carrierLookup.singleLookup',
  bulkLookup = 'user.services.carrierLookup.bulkLookup',
  history = 'user.services.carrierLookup.history',
  flow = 'user.services.carrierLookup.flow',
}
export enum OldEmailLookupRoutes {
  index = 'user.services.emailLookup',
  singleLookup = 'user.services.emailLookup.singleLookup',
  bulkLookup = 'user.services.emailLookup.bulkLookup',
  history = 'user.services.emailLookup.history',
  flow = 'user.services.emailLookup.flow',
}
export enum OldFormsRoutes {
  index = 'user.services.forms',
  subscribe = 'user.services.forms.subscribe',
  clickToText = 'user.services.forms.clickToText',
  newClickToText = 'user.services.forms.clickToText.new',
  editClickToText = 'user.services.forms.clickToText.edit',
  editSubscribe = 'user.services.forms.subscribe.edit',
}
export const OldPointAiRoutes = {
  root: 'user.services.pointAi',
  main: 'user.services.pointAi.main',
  websites: 'user.services.pointAi.main.websites',
  documents: 'user.services.pointAi.main.documents',
  websitesDownloaded: 'user.services.pointAi.websitesDownloaded',
} as const
